import { t } from 'i18next';
import { TEquipmentHoursSelection } from '../DashboardCardSettingsDialog';

export function equipmentHoursDataKey(
  isMultiEquipmentEnabled: boolean,
  equipmentHoursSelection?: TEquipmentHoursSelection | undefined
): 'total' | 'overtime' | 'doubletime' | 'totalWithAddOn' | 'addOn' {
  return isMultiEquipmentEnabled
    ? equipmentHoursSelection === 'equipmentAddOnHours'
      ? 'addOn'
      : equipmentHoursSelection === 'equipmentLaborHours'
        ? 'total'
        : 'totalWithAddOn'
    : 'total';
}

export function equipmentHoursTitle(
  isMultiEquipmentEnabled: boolean,
  equipmentHoursSelection?: TEquipmentHoursSelection | undefined
): string {
  return isMultiEquipmentEnabled
    ? equipmentHoursSelection === 'equipmentAddOnHours'
      ? t('Equip. Add-On Hours')
      : equipmentHoursSelection === 'equipmentLaborHours'
        ? t('Equip. Labor Hours')
        : t('Total Equip. Hours')
    : t('Total Equip. Hours');
}
